import { render, staticRenderFns } from "./ScoreboardSummaryCard.vue?vue&type=template&id=701a5c00&scoped=true"
import script from "./ScoreboardSummaryCard.vue?vue&type=script&lang=ts"
export * from "./ScoreboardSummaryCard.vue?vue&type=script&lang=ts"
import style0 from "./ScoreboardSummaryCard.vue?vue&type=style&index=0&id=701a5c00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701a5c00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VContainer,VRow})
